import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import TemplateGallery from "../../commonComponents/CC_templateGallery";
import SnippetsGrid from '../../components/snippetsGrid';
import NearestStoreFilesGrid from "../../components/nearestStoreFilesGrid";

import {ccColorDarkTeal, linkStyle} from "../../components/helpersStyles";
import { IconButton, Tooltip } from '@mui/material';
import { Icon as Iconify } from '@iconify/react';
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../../commonComponents/styledTexts';

import introJs from 'intro.js';
import 'intro.js/introjs.css'
import '../../ccIntroJs/ccIntroJsStyles.css'
import { CcIntroJsStyledText } from '../../ccIntroJs/ccIntroJsStyledText';
import { showIntroJsTourForCurrentPage } from '../../ccIntroJs/ccIntroJsDisplayLogic';
import { lionIcons } from "../../components/helpersIcons";

export default function ProductHomeNearestStore() {
    const [createNewFile, setCreateNewFile] = useState(false)

    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        showIntroJsTourForCurrentPage(introJs)
    }, [])

    const createNewStoresFile = () => {
        setCreateNewFile(true)
    }
    const handleFileCreateChange = (info) => {
        //the grid handles everything --> no need to do anything here
        //we use the event to change the display mode of the grid
        setCreateNewFile(false)
    }

    return <div>
            <CcTitle>
                Nearest Store
            </CcTitle>
            <div className="w-fit" data-intro={CcIntroJsStyledText({title: 'Start here', mainText: 'This launches a wizard that will help you to: <ul class="list-disc ml-4"> <li>Create/select a <span class="font-semibold">data connection</span></li> <li>Create/select a <span class="font-semibold">template</span></li><li>Create an <span class="font-semibold">element</span></li></ul><div class="mt-2">A <span class="font-semibold">data connection</span> allows you to import external data and use it in your templates</div><div class="mt-2">A <span class="font-semibold">template</span> is a reusable design. You can create multiple elements from the same template</div><div class="mt-2">An <span class="font-semibold">element</span> is the html tag to copy into your email</div>'})}>
                <Link to={`/workflow/28`} style={linkStyle}> 
                    <CcCreateNewSnippet className="mt-4" >Create new Nearest Store</CcCreateNewSnippet>
                </Link>
            </div>

            <div className="mt-6 flex flex-row gap-x-1 items-center">
                <CcSubSectionTitle className="">Stores files</CcSubSectionTitle>
                 <Tooltip title='Upload a new file' placement='right'><IconButton sx={{color: ccColorDarkTeal, }} onClick={createNewStoresFile}><Iconify icon={lionIcons.Icon_Actions_Add} width="32" height="32" /></IconButton></Tooltip>
            </div>

            <div className="h-[360px]">
                <NearestStoreFilesGrid createNew={createNewFile} onFileChange={handleFileCreateChange} />
            </div>

            <div className="w-fit" data-intro={CcIntroJsStyledText({title: 'Elements section', mainText: '<div>List of all the Elements you created</div><div>You can edit an element even if you have already put it in a live email</div>'})}>
                <CcSubSectionTitle className="mt-6">Latest Nearest Store Elements</CcSubSectionTitle>
            </div>
            <SnippetsGrid productTypeId={28}
                 //editCall={(id, typeId) => editSnippet(id, typeId)}
             />

    </div>
}